import { LayerFeatureType } from "./LayerFeatureType.js";
import { OLSourceUtility } from "../../../../utility/common/olSourceUtility.js";
import { OLMapUtility } from "../../../../utility/common/OLMapUtility.js";
import { GeometryUtility } from "../../../../utility/common/GeometryUtility.js";
import { SegmentType } from "../../../../utility/tdtService/BusTransfer/Model/SegmentType.js";
import { AssetsConfig } from "../../../../config/AssetsConfig.js";
import { SegmentStation } from "../../../../utility/tdtService/BusTransfer/Model/SegmentStation.js";
import { ArrayUtility } from "../../../../utility/common/ArrayUtility.js";
// import bussegmentendoverlay from "../UCOverlay/BusSegmentEndOverlay.vue";




export class RouteLayer {

    constructor() {
        this.curMap = null;

        this.startPntIconSrc = AssetsConfig.route_startPoint;// "../../../../assets/onlineMap/poi/startPoint.png";
        this.endPntIconSrc = AssetsConfig.route_endPoint;// "../../../../assets/onlineMap/poi/endPoint.png";
        this.viaPntIconSrc=AssetsConfig.route_viaPoint;
        this.busstationIconSrc = AssetsConfig.busstation;// "../../../../assets/onlineMap/poi/busstation.png";
        this.subwayIconSrc = AssetsConfig.subwaystation;
    }

    /**
     * 添加导航线
     * @param {*} pnts 
     */
    addDriveRouteLine(pnts,viaPnts) {
        if (!pnts) return;

        let startPnt = new ol.geom.Point(pnts[0]);
        let endPnt = new ol.geom.Point(pnts[pnts.length - 1]);
        let viaPoints=new Array();

        let tempViaPnt=null;
        let tempOLPnt=null;
        for(let tempIndex=0;tempIndex<viaPnts.length;tempIndex++)
        {   
            tempViaPnt=viaPnts[tempIndex];
            tempOLPnt=new ol.geom.Point(tempViaPnt);
            viaPoints.push(tempOLPnt);
        }
        
        let lineFeature = this._createLineFeature(pnts, LayerFeatureType.routelayer_drive_addRouteLine);
        let startPointFeature = this._createEndPointFeature(startPnt, true, LayerFeatureType.routelayer_drive_addRouteLine);
        let endPointFeature = this._createEndPointFeature(endPnt, false, LayerFeatureType.routelayer_drive_addRouteLine);
        let viaPointFeatures=this._createViaPointFeatures(viaPoints,LayerFeatureType.routelayer_drive_addRouteLine);


        let features = new Array();
        features.push(lineFeature);
        features.push(startPointFeature);
        features.push(endPointFeature);
        ArrayUtility.addTargetToOri(features,viaPointFeatures);

        RouteLayer.layer.getSource().addFeatures(features);
    }

    /**
     * 添加选中的线路项
     * @param {*} pnts 
     */
    addDriveSelectLine(pnts) {

        if (!pnts) return;

        //首先清除之前的要素
        let existFeats = LayerFeatureType.findFeaturesByFeatType(RouteLayer.layer.getSource(), RouteLayer.field_featTypeName, LayerFeatureType.routelayer_drive_selectRouteItemLine);

        if (existFeats && existFeats.length > 0) {
            OLSourceUtility.removeFeatures(RouteLayer.layer.getSource(), existFeats);
        }

        let features = new Array();
        //线要素
        let lineFeature = this._createSelectSegmentFeature(pnts, LayerFeatureType.routelayer_drive_selectRouteItemLine);

        features.push(lineFeature);

        RouteLayer.layer.getSource().addFeatures(features);
    }

    /**
     * 添加公交线路项
     * @param {*} lineItem 
     */
    addBusLineItem(lineItem) {

        if (!lineItem) return;

        let segmentItems = lineItem.segments;
        let features = new Array();

        let typeClassify = segmentItems.classifyByType();
        let mapCRSCode = OLMapUtility.getProjectionCode(this.curMap);


        let tempSegmentItems = null;
        let tempSegmentLineItems = null;
        let tempSegmentLineItem = null;
        let tempLinePnts = null;
        let tempLineFeature = null;
        for (let tempType in typeClassify) {
            if (tempType == null) continue;
            tempSegmentItems = typeClassify[tempType];
            if (!tempSegmentItems || tempSegmentItems.length == 0) continue;

            tempSegmentLineItems = tempSegmentItems.getSegmentLineItems();
            for (let tempItemIndex = 0; tempItemIndex < tempSegmentLineItems.objects.length; tempItemIndex++) {
                tempSegmentLineItem = tempSegmentLineItems.objects[tempItemIndex];
                tempLinePnts = tempSegmentLineItem.getPoints();
                if (tempSegmentLineItem.crsCode != mapCRSCode) {
                    tempLinePnts = GeometryUtility.transformPoints(tempLinePnts, tempSegmentLineItem.crsCode, mapCRSCode);
                }

                //线要素
                if (tempType == SegmentType.Walk) {
                    tempLineFeature = this._createWalkLineFeature(tempLinePnts, LayerFeatureType.routelayer_bus_addBusLineItem);
                }
                else {
                    tempLineFeature = this._createLineFeature(tempLinePnts, LayerFeatureType.routelayer_bus_addBusLineItem);
                }

                features.push(tempLineFeature);
            }
        }

        let startStation = lineItem.getStartStation();
        let endStation = lineItem.getEndStation();

        let startPnt = new ol.geom.Point([startStation.lon, startStation.lat]);
        let endPnt = new ol.geom.Point([endStation.lon, endStation.lat]);

        let startPointFeature = this._createEndPointFeature(startPnt, true, LayerFeatureType.routelayer_bus_addBusLineItem);
        let endPointFeature = this._createEndPointFeature(endPnt, false, LayerFeatureType.routelayer_bus_addBusLineItem);
        features.push(startPointFeature);
        features.push(endPointFeature);


        let endStations = segmentItems.getEndStations();
        let segmentTypes=new Array();
        segmentTypes.push(SegmentType.Bus);
        segmentTypes.push(SegmentType.Subway);
        segmentTypes.push(SegmentType.TransferInSubway);
        
        let filterStations = SegmentStation.selectBySegmentTypes(endStations,segmentTypes);

        let stationFeatures = this._createEndStationFeatures(filterStations,LayerFeatureType.routelayer_bus_busSegmentEnd);
        ArrayUtility.addTargetToOri(features,stationFeatures);
        

        RouteLayer.layer.getSource().addFeatures(features);
    }

    /**
     * 添加公交线段项
     * @param {*} segmentItem 
     */
    addBusSegmentItem(segmentItem) {
        if (!segmentItem) return;

        let existFeats = LayerFeatureType.findFeaturesByFeatType(RouteLayer.layer.getSource(), RouteLayer.field_featTypeName, LayerFeatureType.routelayer_bus_addBusSegmentItem);

        if (existFeats && existFeats.length > 0) {
            OLSourceUtility.removeFeatures(RouteLayer.layer.getSource(), existFeats);
        }

        let features = new Array();

        let lineItems = segmentItem.lines;

        let pnts = lineItems.getPoints();

        let mapCRSCode = OLMapUtility.getProjectionCode(this.curMap);

        if (segmentItem.crsCode != mapCRSCode) {
            pnts = GeometryUtility.transformPoints(pnts, segmentItem.crsCode, mapCRSCode);
        }

        //线要素
        let lineFeature = this._createSelectSegmentFeature(pnts, LayerFeatureType.routelayer_bus_addBusSegmentItem);

        features.push(lineFeature);

        RouteLayer.layer.getSource().addFeatures(features);
    }

    /**
     * 设置焦点为公交线段终点
     * @param {*} segmentItem 
     */
    focusedBusSegmentEnd(segmentItem) {
        if (!segmentItem) return;

        let existFeats = LayerFeatureType.findFeaturesByFeatType(RouteLayer.layer.getSource(), RouteLayer.field_featTypeName, LayerFeatureType.routelayer_bus_focusedBusSegmentEnd);

        if (existFeats && existFeats.length > 0) {
            OLSourceUtility.removeFeatures(RouteLayer.layer.getSource(), existFeats);
        }

        let stationEnd = segmentItem.stationEnd;
        let stationCoordinates = [stationEnd.lon, stationEnd.lat];


        let mapCRSCode = OLMapUtility.getProjectionCode(this.curMap);
        let segmentCRSCode = segmentItem.crsCode;
        if (segmentCRSCode !== mapCRSCode) {
            stationCoordinates = GeometryUtility.transformPoints(stationCoordinates, segmentCRSCode, mapCRSCode);
        }

        let stationPoint = new ol.geom.Point(stationCoordinates);
        let stationFeature = RouteLayer.createBusSegmentEndInitFeature(stationPoint, segmentItem);// new ol.Feature(

        let stationIconStyle = null;
        if (stationEnd.isBusType()) {
            stationIconStyle = new ol.style.Style({
                image: new ol.style.Icon(({
                    opacity: 1,
                    // anchor: [0.5, 46],
                    // anchorXUnits: 'fraction',
                    // anchorYUnits: 'pixels',
                    src: this.busstationIconSrc
                }))
            });
        }
        else if (stationEnd.isSubwayType()) {
            stationIconStyle = new ol.style.Style({
                image: new ol.style.Icon(({
                    opacity: 1,
                    // anchor: [0.5, 46],
                    // anchorXUnits: 'fraction',
                    // anchorYUnits: 'pixels',
                    src: this.subwayIconSrc
                }))
            });
        }
        else if (stationEnd.isLinePlanEnd) {
            stationIconStyle = new ol.style.Style({
                image: new ol.style.Icon(({
                    opacity: 1,
                    // anchor: [0.5, 46],
                    // anchorXUnits: 'fraction',
                    // anchorYUnits: 'pixels',
                    src: this.endPntIconSrc
                }))
            });
        }



        stationFeature.setStyle(stationIconStyle);

        let features = new Array();
        features.push(stationFeature);
        RouteLayer.layer.getSource().addFeatures(features);
    }



    /**
     * 清除
     */
    clear() {
        let featTypes = new Array();
        featTypes.push(LayerFeatureType.routelayer_drive_addRouteLine);
        featTypes.push(LayerFeatureType.routelayer_drive_selectRouteItemLine);
        featTypes.push(LayerFeatureType.routelayer_bus_addBusLineItem);
        featTypes.push(LayerFeatureType.routelayer_bus_addBusSegmentItem);
        featTypes.push(LayerFeatureType.routelayer_bus_focusedBusSegmentEnd);

        let features = LayerFeatureType.findFeaturesByFeatTypes(RouteLayer.layer.getSource(), RouteLayer.field_featTypeName, featTypes);
        OLSourceUtility.removeFeatures(RouteLayer.layer.getSource(), features);
    }

    /**
     * 创建线要素
     * @param {*} pnts 
     * @param {*} lineFeatureType 
     */
    _createLineFeature(pnts, lineFeatureType) {
        let lineStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#3385ff',
                width: 8,
                lineCap: 'round',
                lineJoin: 'round'
            })
            // ,
            // image: new ol.style.Circle({
            //     radius: 2,
            //     fill: new ol.style.Fill({
            //         color: '#f00'
            //     })
            // })
        })

        let line = new ol.geom.LineString(pnts);
        //线要素
        let lineFeature = new ol.Feature(
            {
                geometry: line,
                featureType: lineFeatureType
            });

        lineFeature.setStyle(lineStyle);
        return lineFeature;
    }

    _createWalkLineFeature(pnts, lineFeatureType) {
        let lineStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                lineDash: [4],
                color: '#089628',
                width: 3,
                lineCap: 'round',
                lineJoin: 'round'
            })
            // ,
            // image: new ol.style.Circle({
            //     radius: 2,
            //     fill: new ol.style.Fill({
            //         color: '#f00'
            //     })
            // })
        })

        let line = new ol.geom.LineString(pnts);
        //线要素
        let lineFeature = new ol.Feature(
            {
                geometry: line,
                featureType: lineFeatureType
            });

        lineFeature.setStyle(lineStyle);
        return lineFeature;
    }

    /**
     * 创建选中线段要素
     * @param {*} pnts 
     * @param {*} segmentFeatureType 
     */
    _createSelectSegmentFeature(pnts, segmentFeatureType) {
        let lineStyle = new ol.style.Style({
            stroke: new ol.style.Stroke({
                color: '#D2542F',
                width: 8
            })
            // ,
            // image: new ol.style.Circle({
            //     radius: 2,
            //     fill: new ol.style.Fill({
            //         color: '#f00'
            //     })
            // })
        })

        let segmentGeometry = new ol.geom.LineString(pnts);
        //线要素
        let segmentFeature = new ol.Feature(
            {
                geometry: segmentGeometry,
                featureType: segmentFeatureType
            });

        segmentFeature.setStyle(lineStyle);

        return segmentFeature;
    }

    /**
     * 创建起始标记端点
     * @param {*} markerPnt 
     * @param {*} isStart 
     * @param {*} markerFeatureType 
     */
    _createEndPointFeature(markerPnt, isStart, markerFeatureType) {

        let srcIcon = null;

        if (isStart) {
            srcIcon = this.startPntIconSrc;
        }
        else {
            srcIcon = this.endPntIconSrc;
        }

        let iconStyle = new ol.style.Style({
            image: new ol.style.Icon(({
                opacity: 1,
                // anchor: [0.5, 46],
                // anchorXUnits: 'fraction',
                // anchorYUnits: 'pixels',
                src: srcIcon
            }))
        });

        let markerFeature = new ol.Feature(
            {
                geometry: markerPnt,
                featureType: markerFeatureType
            }
        );

        markerFeature.setStyle(iconStyle);

        return markerFeature;
    }

    _createViaPointFeatures(olpnts,markerFeatureType)
    {   
        let features=new Array();
        if(!olpnts || olpnts.length===0)return features;

        let srcIcon = this.viaPntIconSrc;

        let iconStyle = new ol.style.Style({
            image: new ol.style.Icon(({
                opacity: 1,
                // anchor: [0.5, 46],
                // anchorXUnits: 'fraction',
                // anchorYUnits: 'pixels',
                src: srcIcon
            }))
        });

        let markerFeature =null;
        let markerPnt=null;
        for(let tempIndex=0;tempIndex<olpnts.length;tempIndex++)
        {   
            markerPnt=olpnts[tempIndex];
            
            markerFeature=new ol.Feature(
                {
                    geometry: markerPnt,
                    featureType: markerFeatureType
                }
            );

            markerFeature.setStyle(iconStyle);
            features.push(markerFeature);
        }   

        return features;
    }

    _createEndStationFeatures(endStations, markerFeatureType) {

        let features = new Array();

        if (!endStations) return;

        let tempStation = null;
        let tempFeature = null;
        let markerPnt = null;
        let iconStyle = null;
        let tempStationType = null;
        for (let tempIndex = 0; tempIndex < endStations.length; tempIndex++) {
            tempStation = endStations[tempIndex];
            markerPnt = new ol.geom.Point([tempStation.lon, tempStation.lat]);

            tempStationType = tempStation.segmentType;
            if (tempStationType === SegmentType.Bus) {
                iconStyle = new ol.style.Style({
                    image: new ol.style.Icon(({
                        opacity: 1,
                        // anchor: [0.5, 46],
                        // anchorXUnits: 'fraction',
                        // anchorYUnits: 'pixels',
                        src: this.busstationIconSrc
                    }))
                });
            }
            else if (tempStationType === SegmentType.Subway
                || tempStationType === SegmentType.TransferInSubway) {
                iconStyle = new ol.style.Style({
                    image: new ol.style.Icon(({
                        opacity: 1,
                        // anchor: [0.5, 46],
                        // anchorXUnits: 'fraction',
                        // anchorYUnits: 'pixels',
                        src: this.subwayIconSrc
                    }))
                });
            }

            tempFeature = new ol.Feature(
                {
                    geometry: markerPnt,
                    featureType: markerFeatureType,
                    featureTypeIsOverlay: true,
                    bindingObject: tempStation.segmentItem
                }
            );

            tempFeature.setStyle(iconStyle);
            features.push(tempFeature);
        }
        
        return features;
    }




    static createBusSegmentEndInitFeature(stationPoint, segmentItem) {
        let stationFeature = new ol.Feature(
            {
                geometry: stationPoint,
                featureType: LayerFeatureType.routelayer_bus_focusedBusSegmentEnd,
                featureTypeIsOverlay: true,
                bindingObject: segmentItem
            }
        )
        return stationFeature;
    }

}


RouteLayer.layer = null;

RouteLayer.field_bindingObject = "bindingObject";

RouteLayer.field_featureTypeIsOverlay = "featureTypeIsOverlay";

RouteLayer.field_featTypeName = "featureType";